import { Routes, Route } from 'react-router-dom';
import SundaySchoolLogin from './login/SundaySchoolLogin';
import SundaySchoolDashboard from './dashboard/SundaySchoolDashboard';
import SundaySchoolAttendance from './attendance/SundaySchoolAttendance';
import SundaySchoolMembers from './members/SundaySchoolMembers';
import SundaySchoolNotices from './notices/SundaySchoolNotices';
import SundaySchoolSchedule from './schedule/SundaySchoolSchedule';
import SundaySchoolStaff from './staff/SundaySchoolStaff';
import SundaySchoolChurch from './church/SundaySchoolChurch';
import SundaySchoolMy from './my/SundaySchoolMy';
import SundaySchoolRequireAuth from './SundaySchoolRequireAuth';

export default function SundaySchoolRouter() {
  return (
    <Routes>
      <Route path="/" element={<SundaySchoolLogin />} />
      <Route
        path="/dashboard"
        element={
          <SundaySchoolRequireAuth>
            <SundaySchoolDashboard />
          </SundaySchoolRequireAuth>
        }
      />
      <Route
        path="/attendance"
        element={
          <SundaySchoolRequireAuth>
            <SundaySchoolAttendance />
          </SundaySchoolRequireAuth>
        }
      />
      <Route
        path="/members"
        element={
          <SundaySchoolRequireAuth>
            <SundaySchoolMembers />
          </SundaySchoolRequireAuth>
        }
      />
      <Route
        path="/notices"
        element={
          <SundaySchoolRequireAuth>
            <SundaySchoolNotices />
          </SundaySchoolRequireAuth>
        }
      />
      <Route
        path="/schedule"
        element={
          <SundaySchoolRequireAuth>
            <SundaySchoolSchedule />
          </SundaySchoolRequireAuth>
        }
      />
      <Route
        path="/staff"
        element={
          <SundaySchoolRequireAuth>
            <SundaySchoolStaff />
          </SundaySchoolRequireAuth>
        }
      />
      <Route
        path="/church"
        element={
          <SundaySchoolRequireAuth>
            <SundaySchoolChurch />
          </SundaySchoolRequireAuth>
        }
      />
      <Route
        path="/my"
        element={
          <SundaySchoolRequireAuth>
            <SundaySchoolMy />
          </SundaySchoolRequireAuth>
        }
      />
    </Routes>
  );
}
